var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        !_vm.showNewManufacturer
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-info",
                on: {
                  click: function ($event) {
                    return _vm.addManufacturer(false)
                  },
                },
              },
              [_vm._v("Добавить\n        производителя\n      ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.addManufacturer(true)
              },
            },
          },
          [
            _vm.showNewManufacturer
              ? _c("div", [
                  _c("div", { staticClass: "flex flex_gap" }, [
                    _c("div", {}, [
                      _c("label", [_vm._v("Название производителя")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newManufacturer.title,
                            expression: "newManufacturer.title",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { required: "", type: "text" },
                        domProps: { value: _vm.newManufacturer.title },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.newManufacturer,
                              "title",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-grow-1" }, [
                      _c("label", [_vm._v("Короткое описание")]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newManufacturer.text,
                            expression: "newManufacturer.text",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text" },
                        domProps: { value: _vm.newManufacturer.text },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.newManufacturer,
                              "text",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-1 flex" }, [
                    _c(
                      "div",
                      { staticClass: "flex-grow-1 pr-2" },
                      [
                        _c("label", [_vm._v("Телефоны")]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-info btn-xs",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.addPhone()
                              },
                            },
                          },
                          [_vm._v("добавить телефон")]
                        ),
                        _vm._v(" "),
                        _vm._l(
                          _vm.newManufacturer.data.phones,
                          function (p, i) {
                            return _c(
                              "div",
                              { key: i, staticClass: "input-group" },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: p.phone,
                                      expression: "p.phone",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { type: "text", placeholder: "номер" },
                                  domProps: { value: p.phone },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(p, "phone", $event.target.value)
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: p.comment,
                                      expression: "p.comment",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: {
                                    type: "text",
                                    placeholder: "комментарий",
                                  },
                                  domProps: { value: p.comment },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        p,
                                        "comment",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-outline-danger",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.addPhone(i)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "icon-fa icon-fa-remove",
                                    }),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-grow-1" }, [
                      _c("label", [_vm._v("Комментарий")]),
                      _vm._v(" "),
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.newManufacturer.data.comment,
                            expression: "newManufacturer.data.comment",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          placeholder: "Комментарии производителя...",
                          rows: "3",
                        },
                        domProps: { value: _vm.newManufacturer.data.comment },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.newManufacturer.data,
                              "comment",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "text-right mt-1" },
                    [
                      _c("LoadingButton", {
                        attrs: {
                          title: "Сохранить",
                          className: "btn btn-success",
                          type: "submit",
                          onClick: () => {},
                          loading: _vm.saveLoading,
                          color: "white",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm.records
      ? _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("table", { staticClass: "table mt-1 table-sm table-hover" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.records, function (r, i) {
                  return _c("tr", { key: i }, [
                    _c("td", [_vm._v(_vm._s(i + 1))]),
                    _vm._v(" "),
                    _c("td", [
                      _c("p", [_vm._v(_vm._s(r.title))]),
                      _vm._v(" "),
                      r.text
                        ? _c("p", { staticClass: "text-muted" }, [
                            _vm._v(_vm._s(r.text)),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "td",
                      _vm._l(r.data.phones, function (p) {
                        return _c("div", { staticClass: "border-bottom" }, [
                          _c("p", [_vm._v(_vm._s(p.phone))]),
                          _vm._v(" "),
                          p.comment
                            ? _c("p", { staticClass: "text-muted" }, [
                                _vm._v(_vm._s(p.comment)),
                              ])
                            : _vm._e(),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(r.data.comment))]),
                  ])
                }),
                0
              ),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Название")]),
        _vm._v(" "),
        _c("th", [_vm._v("телефоны")]),
        _vm._v(" "),
        _c("th", [_vm._v("комментарий")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }